module.exports = __webpack_public_path__ + "img/v4_insuranceFundTransaction_h.cd5387a3.png";